{#if !hideOnlineLabel}
<div class="{person.online === true?'chatwith-active':'chatwith-inactive'}">
    <div class="chatwith-status chatwith-online">
        <span class="chatwith-circle"></span>
        {#if person.online === true} Online{:else} Offline{/if}
    </div>
</div>
{/if}

<script>
    export let person;
    export let hideOnlineLabel = false;
</script>
